// extracted by mini-css-extract-plugin
module.exports = {"toggleLabel":"GfeToggle_toggleLabel__2Rj_H"};